import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from '@mui/material/Container';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import TextField from "@mui/material/TextField";
import SearchIcon from '@mui/icons-material/Search';
import ModeIcon from '@mui/icons-material/Mode';
import Grid from '@mui/material/Grid';
import TablePagination from '@mui/material/TablePagination';
import Skeleton from '@mui/material/Skeleton';
import Chip from '@mui/material/Chip';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import 'react-toastify/dist/ReactToastify.css';

import Products from "../../collections/products";

const ListProducts = (props) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showProducts, setShowProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [typeFilter, setTypeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    props.setPageTitle("Danh sách sản phẩm");

    const fetchProducts = async () => {
      const listProducts = new Products();
      await listProducts.fetch();
      console.log(listProducts);
      setProducts(listProducts.items);
      setShowProducts(listProducts.items);
    }

    fetchProducts();
    setLoading(false);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditProduct = (id, event) => {
    event.stopPropagation();
    navigate(`/products/edit/${id}`);
  };

  const applyFilters = () => {
    if (!products) return;

    let filtered = products.filter(product => {
      // Name filter
      const matchesName = product.name.toLowerCase().includes(searchTerm.toLowerCase());

      // Type filter
      const matchesType =
        typeFilter === 'all' ||
        (typeFilter === 'combo' && product.is_combo) ||
        (typeFilter === 'regular' && !product.is_combo);

      // Status filter
      const matchesStatus =
        statusFilter === 'all' ||
        (statusFilter === 'active' && product.status === 'ACTIVE') ||
        (statusFilter === 'inactive' && product.status === 'INACTIVE');

      return matchesName && matchesType && matchesStatus;
    });

    setShowProducts(filtered);
    setPage(0);
  };

  useEffect(() => {
    applyFilters();
  }, [searchTerm, typeFilter, statusFilter, products]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleTypeFilterChange = (event) => {
    setTypeFilter(event.target.value);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  if (loading) {
    return (
      <Skeleton
        animation="wave"
        variant="rectangular"
        height={250}
        sx={{ mt: 3, ml: '250px' }}
      />
    );
  }

  return (
    <Container sx={{ mt: 3 }}>
      <Grid container alignItems="center" spacing={2} sx={{ mb: 3 }}>
        <Grid item>
          <Button
            variant="outlined"
            onClick={() => navigate('/createproduct')}
            sx={{
              textTransform: 'none',
              height: "px",
              fontSize: "15px",
              backgroundColor: "transparent",
            }}
            startIcon={<AddIcon />}
          >
            Thêm sản phẩm
          </Button>
        </Grid>
        <Grid item sx={{ marginLeft: 'auto' }}>
          <FormControl sx={{ minWidth: 150, mr: 2 }}>
            <InputLabel>Loại sản phẩm</InputLabel>
            <Select
              value={typeFilter}
              onChange={handleTypeFilterChange}
              label="Loại sản phẩm"
            >
              <MenuItem value="all">Tất cả</MenuItem>
              <MenuItem value="regular">Thường</MenuItem>
              <MenuItem value="combo">Combo</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 150, mr: 2 }}>
            <InputLabel>Trạng thái</InputLabel>
            <Select
              value={statusFilter}
              onChange={handleStatusFilterChange}
              label="Trạng thái"
            >
              <MenuItem value="all">Tất cả</MenuItem>
              <MenuItem value="active">Hoạt động</MenuItem>
              <MenuItem value="inactive">Ngừng hoạt động</MenuItem>
            </Select>
          </FormControl>
          <TextField
            sx={{
              width: "300px",
              borderRadius: "30px",
              fontSize: "15px",
              backgroundColor: "transparent",
            }}
            onChange={handleSearchChange}
            id="search-results-menu"
            name="name"
            type="text"
            placeholder="Tìm sản phẩm..."
            InputProps={{
              endAdornment: <SearchIcon />,
            }}
          />
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table aria-label="orders table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderRight: 1, borderColor: 'grey.200' }}>ID</TableCell>
              <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>Image</TableCell>
              <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>Tên sản phẩm</TableCell>
              <TableCell align="left" sx={{ width: 120, borderRight: 1, borderColor: 'grey.200' }}>Loại</TableCell>
              <TableCell align="left" sx={{ width: 120, borderRight: 1, borderColor: 'grey.200' }}>Trạng thái</TableCell>
              <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>Giá mới nhất</TableCell>
              <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>Mô tả</TableCell>
              <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>Hạn sử dụng</TableCell>
              <TableCell align="left" sx={{ width: 100, borderRight: 1, borderColor: 'grey.200' }}>Tỉ lệ chuyển đổi</TableCell>
              <TableCell align="left" sx={{ width: 100, borderRight: 1, borderColor: 'grey.200' }}>Hành động</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {showProducts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((product) => {
              const isInactive = product.status === 'INACTIVE';
              return (
                <TableRow
                  key={product.ID}
                  hover
                  onClick={() => navigate(`/products/edit/${product.id}`)}
                  sx={{
                    cursor: 'pointer',
                    opacity: isInactive ? 0.6 : 1,
                    backgroundColor: isInactive ? 'grey.100' : 'inherit',
                  }}
                >
                  <TableCell component="th" scope="row" sx={{ borderRight: 1, borderColor: 'grey.200' }}>{product.id}</TableCell>
                  <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>
                    {product.image ? <img src={product.image} alt={product.name} style={{ width: '100px', height: '100px' }} /> : null}
                  </TableCell>
                  <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>{product.name}</TableCell>
                  <TableCell align="left" sx={{ width: 120, borderRight: 1, borderColor: 'grey.200' }}>
                    <Chip
                      label={product.is_combo ? "Combo" : "Thường"}
                      color={product.is_combo ? "secondary" : "primary"}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell align="left" sx={{ width: 120, borderRight: 1, borderColor: 'grey.200' }}>
                    <Chip
                      label={isInactive ? "Ngừng HĐ" : "Hoạt động"}
                      color={isInactive ? "default" : "success"}
                      size="small"
                      variant={isInactive ? "outlined" : "filled"}
                    />
                  </TableCell>
                  <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>{product.latest_price}</TableCell>
                  <TableCell align="left" sx={{ width: 150, borderRight: 1, borderColor: 'grey.200' }}>{product.description}</TableCell>
                  <TableCell align="left" sx={{ width: 100, borderRight: 1, borderColor: 'grey.200' }}>{product.expire_days}</TableCell>
                  <TableCell align="left" sx={{ width: 100, borderRight: 1, borderColor: 'grey.200' }}>{product.convert_rate}</TableCell>
                  <TableCell align="left" sx={{ width: 100, borderRight: 1, borderColor: 'grey.200' }}><Button
                    variant="contained"
                    color="primary"
                    onClick={(event) => handleEditProduct(product.id, event)}
                    startIcon={<ModeIcon />}
                    sx={{ mr: 2, width: "150px" }}
                  >
                    Chỉnh sửa
                  </Button>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={showProducts.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Số hàng mỗi trang"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} của ${count}`}
        />
      </TableContainer>
    </Container>
  )
}

export default ListProducts;
